module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-italic-b202ab6c07851a0a71c09bbc4e9520cb.ttf";